/**
 * Helper (pure) ของฉากที่ใช้ "คลิปจากลิงก์ภายนอก" (external_video_link — มาจาก MeLab)
 *
 * ทำไมต้องมี: ฉากที่มี external_video_link หลังบ้านใช้คลิปจากลิงก์เป็นทั้งภาพและเสียงของฉาก —
 * graph.py บังคับ use_animated = true และ video_audio_mode = "video", ข้ามการ generate วิดีโอ
 * และเสียงของฉากมาจากคลิปนั้น ⇒ ช่อง Voice / Image Model / Video Model ในตัวแก้ไขฉากไม่มีผลกับผลลัพธ์
 * (TTS/ภาพยังถูกสร้างแต่ไม่ถูกใช้) หน้าเว็บจึงควรซ่อนช่องเหล่านั้นแทนที่จะโชว์ให้ผู้ใช้สับสน
 *
 * ค่ามาถึงหน้าบ้านได้ 2 ทาง: items[] ของ /script2vdo/{thread}/output และ final_script.items[] ใน /state
 * (ไหลเข้า scriptWithImage) ⇒ ต้องดูทั้งสองที่ โดยเชื่อค่าจาก /output ก่อน
 */
import { DirectScriptOutputItem, ScriptWithImageItem } from "../types/MeGenTypes";

/** "มีลิงก์" = string ที่ trim แล้วไม่ว่าง — null/undefined/""/ช่องว่างล้วน ถือว่าไม่มี (หลังบ้านคืน null ได้ปกติ) */
export const hasExternalVideoLink = (link: string | null | undefined): boolean =>
  typeof link === "string" && link.trim() !== "";

/** ลิงก์ที่ฉากนี้ใช้จริง (trim แล้ว) หรือ null ถ้าไม่มี — /output มาก่อน แล้วค่อยถอยไปใช้ค่าใน script item */
export const externalVideoLinkOf = (
  item: Pick<ScriptWithImageItem, "external_video_link">,
  outputItem?: Pick<DirectScriptOutputItem, "external_video_link"> | null,
): string | null => {
  const fromOutput = outputItem?.external_video_link;
  const fromItem = item?.external_video_link;
  const link = hasExternalVideoLink(fromOutput) ? fromOutput : fromItem;
  // hasExternalVideoLink การันตีว่าเป็น string แล้ว แต่ signature คืน boolean (ไม่ใช่ type predicate) จึงต้อง String()
  return hasExternalVideoLink(link) ? String(link).trim() : null;
};
